import {createFetchListReducer} from 'common/reducers/utils';

const defaultReducer = createFetchListReducer({
  name: 'agency',
  pluralName: 'agencies',
});

export default function agencies(state = {
  isFetching: false,
  items: {},
}, action) {
  return defaultReducer(state, action);
}



// WEBPACK FOOTER //
// ./src/ondemand/reducers/agency.js